import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { catchError, first, throwError } from 'rxjs';
import { LoadPreferencesDashboard } from './store/preferences/dashboard/preferences-dashboard.actions';
import { LoadPreferencesProviders } from './store/preferences/providers/preferences-providers.actions';
import { LoadPreferencesFinops } from './store/preferences/finops/preferences-finops.actions';
import { LoadPreferencesCharts } from './store/preferences/charts/preferences-charts.actions';
import { InitFilters } from './store/preferences/filters/preferences-filters.actions';
import { Login } from './store/users/users.actions';

export const appResolver: ResolveFn<void> = (route, state, store: Store = inject(Store)) => {
  return store.dispatch(
    [
      new Login(),
      new LoadPreferencesDashboard(),
      new LoadPreferencesProviders(),
      new LoadPreferencesFinops(),
      new LoadPreferencesCharts(),
      new InitFilters()
    ]
  ).pipe(
    first(),
    catchError(err => {
      console.error(
        'Issue appResolver: ', err
      )
      return throwError(() => err)
    })
  )
};
